import { useState } from 'react';
import { Conversation, TestControls } from '../components';
import { ChooseAvatar } from '../components/ChooseAvatar/ChooseAvatar';
import { Avatars } from '../state';

export const ConversationScreen = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [currentAvatar, setCurrentAvatar] = useState<Avatars>(Avatars.ALTERMAIND);

  return (
    <>
      {currentStep === 0 && (
        <ChooseAvatar
          currentAvatar={currentAvatar}
          setCurrentAvatar={setCurrentAvatar}
          setCurrentStep={setCurrentStep}
        />
      )}
      {currentStep === 1 && <TestControls setCurrentStep={setCurrentStep} />}
      {currentStep === 2 && <Conversation currentAvatar={currentAvatar} />}
    </>
  );
};
